import { Component, inject, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';
import { environment } from '../environments/environment';
import { NavigationComponent } from './layout/navigation/navigation.component';

@Component({
  selector: 'dnv-root',
  templateUrl: './app.component.html',
  standalone: true,
  imports: [RouterOutlet, NavigationComponent],
})
export class AppComponent implements OnInit {
  title = inject(Title);

  ngOnInit(): void {
    this.title.setTitle(environment.title);
  }
}
